import onelps from '../api';

export const login = async function(username, password, rememberMe, dispatchFn) {
	try {
		const result = await onelps.actions.login({ username: username, password: password, useRememberMe: rememberMe });

		return result;
	}
	catch (e) {
		dispatchFn({ type: 'SHOW_SERVER_ERROR' });
	}
};
